<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9639 19.8928C21.9293 18.0408 23.1562 15.4137 23.1562 12.5C23.1562 6.89086 18.6091 2.34375 13 2.34375C7.39086 2.34375 2.84375 6.89086 2.84375 12.5C2.84375 15.4137 4.07068 18.0408 6.03607 19.8928C7.85429 21.6062 10.3045 22.6562 13 22.6562C15.6955 22.6562 18.1457 21.6062 19.9639 19.8928ZM6.90117 18.5545C8.33293 16.7685 10.5329 15.625 13 15.625C15.4671 15.625 17.6671 16.7685 19.0988 18.5545C17.542 20.1227 15.3844 21.0938 13 21.0938C10.6156 21.0938 8.45805 20.1227 6.90117 18.5545ZM16.9062 9.375C16.9062 11.5324 15.1574 13.2812 13 13.2812C10.8426 13.2812 9.09375 11.5324 9.09375 9.375C9.09375 7.21764 10.8426 5.46875 13 5.46875C15.1574 5.46875 16.9062 7.21764 16.9062 9.375Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgProfile',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>